import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  Typography
} from '@material-ui/core';

import CompanyDetail from './CompanyDetail';

const styles = theme => ({
  root: {
    flexGrow: 1,
    margin: '0px',
    padding: '50px 0px',
    backgroundColor: '#F8F8F8',
  },
  title: {
    margin: '20px 0px',
    fontWeight: 700,
  }
});

const companyDatas = [
  {
    name: '社名',
    value: 'グリナーチテクノロジーズ合同会社',
  },
  {
    name: '設立',
    value: '2018年7月19日',
  },
  {
    name: '代表者',
    value: '代表社員　手塚 正裕',
  },
  {
    name: '所在地',
    value: '東京都港区浜松町二丁目２番１５号',
  },
  {
    name: '事業内容',
    value: 'システム開発',
  },
];

class Company extends Component {

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="display1" align="center" className={classes.title}>
          会社概要
        </Typography>
        {companyDatas.map(data => (
          <CompanyDetail
            name={data.name}
            value={data.value}
          />
        ))}
      </div>
    );
  }
};

Company.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Company);



// WEBPACK FOOTER //
// ./src/components/index/Company.js